import * as types from './rawExamDataActionType';

//Raw Exam Data - start
export const fetchRawExamDataRequest = (data) => ({
    type: types.FETCH_RAW_EXAM_DATA_REQUEST,
    payload: data
});
export const fetchRawExamDataSuccess = (data) => ({
    type: types.FETCH_RAW_EXAM_DATA_SUCCESS,
    payload: data
});
export const fetchRawExamDataFailure = (error) => ({
    type: types.FETCH_RAW_EXAM_DATA_FAILURE,
    payload: error
});
//Raw Exam Data - end